import { MediaGet } from "../../typings/thor";

export class MultipleImageController {
    public static $inject: string[] = ["$translate"];

    // Binded
    public count: number;
    public medias: MediaGet[];
    public type: string;

    private videoCount: number;

    constructor(private $translate: ng.translate.ITranslateService) {}

    public getCountLabel() {
        if (this.count === undefined) {
            return null;
        }
        let label;

        this.videoCount = this.medias.filter(media => media.meta?.video_embed).length;

        switch (this.type) {
            case "past-sale-item":
                return null;
            case "item":
            case "search-item":
            case "my-page":
                label = this.videoCount ? "n_photo_video" : "n_photo";
                break;
            case "sale":
            case "online-container":
                label = "n_lot";
                break;
            default:
                break;
        }

        return label ? this.$translate.instant(label, [this.count, this.videoCount]) : this.count;
    }
}
